export enum AppliancesTileTexts {
    TITLE = 'screens.dashboard.appliances.title',
    LABEL_CONSUMPTION_IN = 'screens.dashboard.appliances.labelConsumptionIn',
    ERROR = 'screens.dashboard.appliances.error',
    LOADING = 'screens.dashboard.appliances.loading',
}
